// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-7fb47655] .el-table .el-table__footer .el-table__cell {\n  background-color: #F3B792;\n}\n[data-v-7fb47655] .el-radio{\n  margin: 0 5px 5px 0 !important;\n  padding: 6px 5px 0 10px;\n}\n[data-v-7fb47655] .el-radio__label{\n  padding-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
